<template>
    <a v-on:click="open_in_new_tab">
        <img v-bind:alt="prop_image_alt_text" v-bind:src="prop_image_url_size_small"/>
    </a>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentImageLinks',

    props:[
        'prop_image_alt_text',
        'prop_image_url_size_medium',
        'prop_image_url_size_small'
    ],

    methods:{
        open_in_new_tab:function(){
            window.open(this.prop_image_url_size_medium)
        }
    },

    data: function()
    {
        return {
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
